import React, { FC } from 'react';
import Link from 'app/components/router/Link';
import { DashboardRoute } from 'app/constants/Routes';
import { User } from 'app/constants/schemas/User';
import { isStaffMember, isTeacher, getAuthUser } from 'app/models/auth/selectors';
import { connect } from 'react-redux';
import { AppState } from 'app/store';
import { useBrand, BrandContextValue } from '../OrganizationContext';
import { LocationDescriptor } from 'history';
import { getBrandDomainLocation } from 'app/utils/brand';
import { getTutorSiteUrl } from 'app/constants/TeacherSite';
import appConfig from 'app/config/client';

interface IProps {
  authUser?: User;
  children: React.ReactNode;
  className?: string;
}

const UserSensitiveLink: FC<IProps> = ({ authUser, children, className }) => {
  const brand = useBrand();
  const brandDefaultLocation = getBrandDomainLocation(brand.defaultDomain);
  const url = getRedirectUrl(authUser, brand, brandDefaultLocation);

  return (
    <Link to={url} className={className}>
      {children}
    </Link>
  );
};

export const getRedirectUrl = (
  authUser: User | undefined,
  brand: BrandContextValue,
  defaultRoute: LocationDescriptor,
) => {
  if (!!authUser) {
    return getDestinationRouteForUser(authUser!, brand, defaultRoute);
  }
  return brand.landingPageUrl ?? defaultRoute;
};

/**
 * Get the redirect route based on the given user and the current site.
 */
export const getDestinationRouteForUser = (
  user: User,
  brand: BrandContextValue,
  defaultRoute: LocationDescriptor,
  useLocalRouting: boolean = false,
) => {
  return isStaffMember(user) || useLocalRouting
    ? DashboardRoute.getPathname()
    : isTeacher(user)
    ? getTutorSiteUrl(appConfig.deployInfo)
    : user.brand === brand.id && brand.dashboardUrl
    ? brand.dashboardUrl : defaultRoute;
};

const mapStateToProps = (state: AppState) => ({
  authUser: getAuthUser(state),
});

export default connect(mapStateToProps)(UserSensitiveLink);
